<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-red"
                      sub-title="350,897"
                      icon="ni ni-active-40"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-orange"
                      sub-title="2,356"
                      icon="ni ni-chart-pie-35"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
              <b-card-header class="border-0">
                  <h3 class="mb-0">Acciones del Pos</h3>
              </b-card-header>
              <div class="card-body table-responsive p-0">
                <table id="ListAcciones" class="table table-hover">
                    <tbody>
                    <tr>
                        <th>Id</th>
                        <th>Descripción</th>
                        <th>Módulo</th>
                        <th>Creado el</th>                                                
                        <!--<th>Estatus</th>-->
                        <th>Acciones</th>
                    </tr>

                    <tr v-for="accion in acciones" :key="accion.id">
                        <td>{{accion.id}}</td>
                        <td>{{accion.descripcion}}</td>
                        <td>{{getModulo(accion.moduloId)}}</td>
                        <td>{{accion.createdAt | myDate}}</td>
                        <!--<td>{{rol.nombre}}</td>-->
                        
                    
                        <!--td><span [ngClass]="{'badge badge-danger':accion.Estatus === -1, 'badge badge-success':accion.Estatus === 1, 'badge badge-warning':accion.Estatus === 0 }">{{accion.Estatus }}</span></td>-->
                        <td>
                        <base-button size="sm"
                            v-b-popover.hover.top="'Editar Acción'"
                            type="secondary"
                            @click="editModal(accion)"
                        >
                        <i class="fa fa-edit"></i>
                        </base-button>                    
                        <!--[ngClass]="{'disabled':accion.Estatus == -1 || accion.Estatus == 0}"-->
                        <base-button size="sm"                            
                            v-b-popover.hover.top="'Anular Acción'"
                            type="danger"
                            @click="deleteAccion(accion.Id)"
                        >
                        <i class="fa fa-trash"></i>
                        </base-button>
                        </td>
                    </tr>
                    </tbody>
                </table>                  
                    <!-- /.card-body 
                    <div class="card-footer">
                        <pagination :data="cajas" @pagination-change-page="getResults"></pagination>
                    </div>
              -->
                  <!-- /.card -->
              </div>
              <b-card-footer class="py-4 d-flex justify-content-end">
                  <base-pagination @change="getResults" aria-controls="ListAcciones" v-model="currentPage" :per-page="perPage" :total="30"></base-pagination>
              </b-card-footer>
          </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>


    <!-- Modal -->
    <b-modal ref="modal-1" size="md" hide-backdrop centered hide-footer>
        <template #modal-title>
            <h5 class="modal-title" v-show="!editmode" id="addNewLabel">Guardar Acción</h5>
            <h5 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Acción</h5>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <div class="modal-body">
              <div class="container">
                <h6 class="heading-small text-muted mb-4">Acción - Módulos</h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        required       
                        type="text"
                        label="Descripción"
                        placeholder="Ej. accionA"                        
                        v-model="form.descripcion"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <label class="form-control-label" for="select-fact-may">Módulos</label>
                      <b-form-select 
                        id="select-fact-may"
                        v-model="form.moduloId" :options="selectModulos">
                      </b-form-select>                      
                      <!--<base-input
                        required
                        type="text"
                        label="Factura al Mayor"
                        placeholder="Ej. 11"
                        v-model="form.facturaAlMayor"
                      >
                      </base-input>-->
                    </b-col>

                  </b-row>                
                </div>
              </div>
            </div>
           
            <div class="modal-footer">
              <b-button size="sm" type="button" class="btn btn-danger" @click="hideModal" >Cerrar</b-button>
              <b-button size="sm" v-show="editmode" type="submit" class="btn btn-success">Actualizar</b-button>
              <b-button size="sm" v-show="!editmode" type="submit" class="btn btn-primary">Guardar</b-button>
            </div>
          </form>
    </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    components: {
      //LightTable,
      //DarkTable,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      selectEdo:{},
      roles: [],
      areas: [],
      acciones:{},      
      form: new Form({
        id: 0,
        descripcion: '',
        rolId: '',
        moduloId:'',
        estatus: true
      }),
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
        modulos: [],
        selectRoles:[{value:"", text:"Seleccione"}],
        selectModulos:[{value:"", text:"Seleccione"}]
      };
    },
    methods: {
      tokenVencido(){
        const UNAUTHORIZED = 401;
        axios.interceptors.response.use(
          response => response,
          error => {
            const {status} = error.response;
            if (status === UNAUTHORIZED) {
              //dispatch(userSignOut());
              console.log("token no valido");
            }
            return Promise.reject(error);
        }
        );
      },
      getResults(page = 1) {      
        axios.get(this.$gate.getApiUrl()+'Accion?page='+page+'&perPage='+this.perPage)
        .then(({ data }) => {
          this.acciones = data;
          //console.log(this.acciones)
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }            
        });
      },      
      detalleCaja(caja){
        this.$refs['modal-Detalle'].show();
      },
      editModal(caja){
        this.editmode = true;
        this.form.reset();        
        this.$refs['modal-1'].show();       
        this.form.fill(caja);
        this.onChangeRol();
      },
      updateCaja(){        
        //this.$gate.getApiUrl()+
        this.form.put(this.$gate.getApiUrl()+'Accion/'+this.form.id)
          .then(() => {
            // success
            Fire.$emit('AfterCreate');
            this.$refs['modal-1'].hide();

            this.$swal({
              title: 'Acción Actualizada',
              icon: 'success',
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              timer: 3000
            })            
          //this.$Progress.finish();
        })
        .catch((e) => {
          //console.log(e)

          //this.$Progress.fail();
        });
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      getModulo(moduloId){        
        if(this.modulos.length >0){
          let itemEnc = this.modulos.find(m => m.id === moduloId);
          if(moduloId>=0){
            return itemEnc.descripcion;
          }else{ 
            return "---";
          }
        }
      },
      getSelectModulos(){
        this.modulos.forEach(element => {
          let data = {value:element.id, text:element.descripcion};
          this.selectModulos.push(data);          
        });
      },
      loadAcciones: async function(){
        //if(this.$gate.isAdminOrAuthor()){
           this.getResults();
          //await axios.get(this.$gate.getApiUrl()+"Accion").then(({ data }) => {this.acciones = data; });
          //await axios.get(this.$gate.getApiUrl()+"Rol").then(({ data }) => {this.roles = data; this.getSelectRoles(); });
          await axios.get(this.$gate.getApiUrl()+"Modulo").then(({ data }) => {this.modulos = data; this.getSelectModulos(); });
        //}
      },

    },
    created(){
      this.loadAcciones();
      Fire.$on('AfterCreate',() => {
        this.loadAcciones();
      });      
    },
    computed:{
      rows() {
        return this.acciones.length
      },
    }
  };
</script>
<style>

</style>
